import React from 'react';
import { ServiceTypes, TypeOfUser } from '@pharmaplan/common';
import { ReactComponent as BillingIcon } from '@pharmaplan/common/assets/icons/billingIcon.svg';
import { ReactComponent as analyticsIcon } from '@pharmaplan/common/assets/icons/analyticsIcon.svg';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { ReactComponent as CoordinateIcon } from '../../../assets/svg/coordinateIcon.svg';
import { ReactComponent as PrimaryIcon } from '../../../assets/svg/primaryIcon.svg';
import { ReactComponent as SecondaryIcon } from '../../../assets/svg/secondaryIcon.svg';
import { ReactComponent as AccountingIcon } from '../../../assets/svg/accountingIcon.svg';
import { ReactComponent as InfoIcon } from '../../../assets/svg/infoIcon.svg';
import { ReactComponent as professionalInfoIcon } from '../../../assets/svg/professionalInfo.svg';
import { ReactComponent as softwareIcon } from '../../../assets/svg/softwareIcon.svg';
import { ReactComponent as contactsIcon } from '../../../assets/svg/contactsIcon.svg';
import { ReactComponent as generalInfoIcon } from '../../../assets/svg/generalInfoIcon.svg';
import { ProfileScreens } from '../../../helpers/Constants';
import strings from '../../../localization';

const { full, self } = ServiceTypes;

const {
  general,
  professionalInfo,
  software,
  billing,
  contacts,
  primary,
  secondary,
  pharmacyInfo,
  accounting,
  coordinates,
  professionalProfileAnalytics,
  pharmacyBilling,
} = ProfileScreens;

const genericAdminSettings = [
  {
    title: strings.general,
    icon: generalInfoIcon,
    id: general,
  },
];

const selfSettingsList = () => {
  const professionalConfig = [
    {
      title: strings.general,
      icon: generalInfoIcon,
      id: general,
    },
    {
      title: strings.professionalInfo,
      icon: professionalInfoIcon,
      id: professionalInfo,
    },
    {
      title: strings.profileAnalytics,
      icon: analyticsIcon,
      id: professionalProfileAnalytics,
    },
    {
      title: strings.software,
      icon: softwareIcon,
      id: software,
    },
    {
      title: strings.contacts,
      icon: contactsIcon,
      id: contacts,
    },
    {
      title: strings.billing,
      icon: ({ fill }: { fill: string }) =>
        (
          <BillingIcon fill={fill} stroke={fill} />
        ),
      id: billing,
    },
  ];
  return ({
    [TypeOfUser.pharmacist]: professionalConfig,
    [TypeOfUser.technician]: professionalConfig,
    [TypeOfUser.student]: professionalConfig,
    [TypeOfUser.pharmacy]: [
      {
        id: pharmacyInfo,
        icon: InfoIcon,
        title: strings.pharmacyInfo,
      },
      {
        id: coordinates,
        icon: CoordinateIcon,
        title: strings.coordinates,
      },
      {
        id: primary,
        icon: PrimaryIcon,
        title: strings.primary,
      },
      {
        id: secondary,
        icon: SecondaryIcon,
        title: strings.secondary,
      },
      {
        id: accounting,
        icon: AccountingIcon,
        title: strings.accounting,
      },
      {
        id: pharmacyBilling,
        icon: ({ fill }: { fill: string }) =>
          (
            <BillingIcon fill={fill} stroke={fill} />
          ),
        title: strings.subscriptionAndBilling,
      },
    ],
    [TypeOfUser.superAdmin]: genericAdminSettings,
    [TypeOfUser.admin]: genericAdminSettings,
    [TypeOfUser.pharmacyAdmin]: genericAdminSettings,
  });
};
export const fullSettingsList = () => {
  const pharmacistConfig = [
    {
      title: strings.general,
      icon: generalInfoIcon,
      id: general,
    },
    {
      title: strings.professionalInfo,
      icon: professionalInfoIcon,
      id: professionalInfo,
    },
    {
      title: strings.software,
      icon: softwareIcon,
      id: software,
    },
    {
      title: strings.contacts,
      icon: contactsIcon,
      id: contacts,
    },
  ];
  return ({
    [TypeOfUser.pharmacist]: pharmacistConfig,
    [TypeOfUser.technician]: pharmacistConfig,
    [TypeOfUser.student]: pharmacistConfig,
    [TypeOfUser.pharmacy]: [
      {
        id: pharmacyInfo,
        icon: InfoIcon,
        title: strings.pharmacyInfo,
      },
      {
        id: coordinates,
        icon: CoordinateIcon,
        title: strings.coordinates,
      },
      {
        id: primary,
        icon: PrimaryIcon,
        title: strings.primary,
      },
      {
        id: secondary,
        icon: SecondaryIcon,
        title: strings.secondary,
      },
      {
        id: accounting,
        icon: AccountingIcon,
        title: strings.accounting,
      },
    ],
    [TypeOfUser.superAdmin]: genericAdminSettings,
    [TypeOfUser.admin]: genericAdminSettings,
    [TypeOfUser.pharmacyAdmin]: genericAdminSettings,
  });
};
export const settingsList = {
  [full]: fullSettingsList,
  [self]: selfSettingsList,
}[ServiceHandler.getService()];
